
import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../Modal/modal.js';
import { SESSION_TIMEOUT_POP } from '../../Constants/strings.js';
import './timeOutPopup.scss';
import alertIcon from '../../Assets/images/svg/session_timeout.svg';

const SessionTimeOutPopup = ({
  handleLoginAction,
  isModelOpen,
  message,
}) => {
  const content = SESSION_TIMEOUT_POP;

  return (
    <FormDialog
      open={isModelOpen}
      isSessionPopup={true}
      dialogCss="popup-message"
      dialogPaperCss="role-popup-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="popup-body-text">
          <div className="popup-alert-icon">
            <img alt="Alert Icon" className="icon-image" src={alertIcon} />
          </div>
          <div className='popup-header'>{content.SESSION_TIMEOUT}</div>
          <div className="popup-message-text">{message}</div>
        </div>
      }
      button2={content.BUTTON_TEXT}
      submitButtonId={content.BUTTON_ID}
      button2Action={() =>
        handleLoginAction(
        )
      }
    />
  );
};

SessionTimeOutPopup.propTypes = {
  handleLoginAction: PropTypes.func.isRequired,
  isModelOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default SessionTimeOutPopup;
